import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { OptionButton } from 'AppSrc/core/components/utility/option-button';
import { saveTabDataToSessionStorage, getTabDataToSessionStorage } from 'AppSrc/core/utility-functions/dash-tab-session-func';
import { leftPadWithZeros } from 'AppSrc/core/utility-functions/number-functions';
import { LoadingSpinner } from 'AppSrc/core/components/utility/loading-spinner';
import { fixedL3Approver, mobileL3Approver, internationalCoordinatorGroups } from 'AppSrc/core/components/forms/form-types/create-crq/section-one/section-one-constants';
import { CoordinatorWorkQueueTable } from './coordinator-work-queue-table';
import {
  NEW_TAB_ID,
  PEER_TAB_ID,
  CIRCUITCHECK_TAB_ID,
  APPROVAL_TAB_ID,
  // REJECTED_TAB_ID,
  PRECLOSURE_TAB_ID,
} from './coordinator-work-queue-constants';
import { EMERGENCY_TAB_ID } from '../crqs-screen/crq-work-queue-constants';


// Display component for the work queue
const CoordinatorWorkQueueDisplayConnect = ({
  handleTabClick,
  selectedTab,
  stats,
  crqList,
  fetching,
  isChangeAnalyst,
  userGroups,
}) => {

  useEffect(() => {
    saveTabDataToSessionStorage(selectedTab, 'BucketTabSession');
    getTabDataToSessionStorage('BucketTabSession');
  }, [selectedTab]);

  const tabs = [
    {
      id: NEW_TAB_ID,
      label: 'CRQs for Review',
    },
    {
      id: PEER_TAB_ID,
      label: 'CRQs for Peer Review',
    },
    {
      id: APPROVAL_TAB_ID,
      label: 'CRQs for Approval',
    },
    // {
    //   id: REJECTED_TAB_ID,
    //   label: 'Rejected CRQs',
    // },
    {
      id: PRECLOSURE_TAB_ID,
      label: 'Pre-Closure Review',
    },
  ];
  // Circuit check tab added for Change Analyst
  if (isChangeAnalyst) {
    tabs.splice(2, 0, {
      id: CIRCUITCHECK_TAB_ID,
      label: 'Circuit Checks',
    });
  }

  const FIXED = 'fixed';
  const MOBILE = 'mobile';
  const isICM = userGroups[FIXED] ? internationalCoordinatorGroups.includes(userGroups[FIXED][0]) : null;
  // The logic here is if a coordinator's user groups has atleast one support group matching with the list of L3 Approvers given for Fixed and Mobile.
  const isL3Approver = !isICM ? (userGroups[FIXED] ? userGroups[FIXED].some((item) => fixedL3Approver.includes(item)) : false) || (userGroups[MOBILE] ? userGroups[MOBILE].some((item) => mobileL3Approver.includes(item)) : false) : null;


  if (isL3Approver) {
    tabs.splice(1, 0, {
      id: EMERGENCY_TAB_ID,
      label: 'Emergency',
    });
  }
  return (
    <div className="coordinator-work-queue">
      <div className="page-content-inner">
        <div className="coordinator-work-queue-tabs">
          {tabs.map(({ id, label }) => (
            <OptionButton
              className={`tab${selectedTab === id ? ' tab-selected' : ''}`}
              option={id}
              onClick={handleTabClick}
              key={id}
            >
              <span className="tab-statistic-number">{leftPadWithZeros((stats[id] || 0), 2)}</span>
              <span className="tab-statistic-label">{label}</span>
            </OptionButton>
          ))}
        </div>
      </div>
      {
        isChangeAnalyst
          ? console.log('coming heree')
          : null
      }
      { fetching ? (
        <div className="coordinator-work-queue-table-loader">
          <LoadingSpinner />
        </div>
      ) : (
        <CoordinatorWorkQueueTable
          tab={selectedTab}
          crqList={crqList}
        />
      )}
    </div>
  );
};

CoordinatorWorkQueueDisplayConnect.propTypes = {
  handleTabClick: PropTypes.func,
  selectedTab: PropTypes.string,
  stats: PropTypes.objectOf(PropTypes.number),
  crqList: PropTypes.arrayOf(PropTypes.object),
  fetching: PropTypes.bool,
  isChangeAnalyst: PropTypes.bool,
  userGroups: PropTypes.objectOf(PropTypes.array),
};

// const mapStateToProps = (state, ownProps) => ({
//   isChangeAnalyst: state && state.auth.isChangeAnalyst,
// });
const mapStateToProps = (state, ownProps) => {
  const isChangeAnalyst = state && state.auth.isChangeAnalyst;
  const userLoggedInCheck = state && state.auth && state.auth.user && state.auth.user.id;
  const userGroups = state && state.auth && state.auth.user && state.auth.user.groups;
  return {
    isChangeAnalyst,
    userLoggedInCheck,
    userGroups,
  };
};
const CoordinatorWorkQueueDisplay = connect(
  mapStateToProps,
)(CoordinatorWorkQueueDisplayConnect);

export { CoordinatorWorkQueueDisplay };

